export default ({ data, id }) => ({
	id,
	type: data.tool_type,
	title: data.source_title,
	minutes: data.minutes,
	description: data.short_description.map(({ text }) => text).join("<br/>"),
	content: data.content,
});
